<template>
    <div class="xiangmu">
<!--        <div class="h-crumbOut">-->
<!--            <div class="h-crumbs">-->
<!--                <el-breadcrumb separator="|">-->
<!--                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
<!--                    <el-breadcrumb-item>套餐管理</el-breadcrumb-item>-->
<!--                </el-breadcrumb>-->
<!--            </div>-->
<!--        </div>-->
      <Breadtabsheader/>
        <div class="h-piece h-mrt30">
            <div class="h-formBox">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="套餐" style="width: 25%;">
                                <el-input v-model="q.packageCode" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="场景" style="width: 25%;">
                                <el-input v-model="q.sceneCode" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="链群" style="width: 25%;">
                                <brselect placeholder="请选择"
                                          category="xsyb_lianqun"
                                          :v="q.lianqunCode"
                                          clearable
                                          v-model="q.lianqunCode">
                                </brselect>
                            </el-form-item>
                            <el-form-item label="状态" style="width: 25%;">
                                <brselect placeholder="请选择"
                                          category="bsom_status"
                                          :v="q.status"
                                          clearable
                                          v-model="q.status">
                                </brselect>
                            </el-form-item>
                        </div>
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="套餐类型" style="width: 25%;">
                                <brselect placeholder="请选择"
                                          category="package_type"
                                          :v="q.packageType"
                                          clearable
                                          v-model="q.packageType">
                                </brselect>
                            </el-form-item>
                            <el-form-item label="销售公司">
                                <brselect category="xsyb_gongsi" :v="q.companycode" v-model="q.companycode" :clearable="true"
                                          style="width:100%"/>
                            </el-form-item>
                        </div>
                    </el-form>
                    <div class="l-screenBox">
                        <div class="l-retrieval">
                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" style="width:1.9rem;"
                                       @click="toNew">新增套餐
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>

            <!--展示表格-->
            <div class="h-table h-mrt30">
                <el-table
                        :data="tableData"
                        @selection-change="handleSelectionChange"
                        ref="multipleTable"
                        :border="true"
                        style="width: 100%"
                        max-height="450"
                >
                    <el-table-column
                            type="selection"
                            width="40"
                            :label="all"
                    >
                    </el-table-column>
                    <el-table-column
                            fixed
                            type="index"
                            label="#"
                            width="40">
                    </el-table-column>
                    <el-table-column
                            label="链群"
                            prop="lianqunName"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            label="套餐编码"
                            prop="packageCode"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            label="套餐名称"
                            prop="packageName"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            label="套餐类型"
                            prop="packageType"
                            width="110">
                        <template slot-scope="scope">
                            {{scope.row.packageType|dictname('package_type')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="经销商"
                            prop="agentName"
                            width="140">
                    </el-table-column>
                    <el-table-column
                            label="销售公司"
                            prop="companycode"
                            :show-overflow-tooltip="true"
                            width="180">
                        <template slot-scope="scope">
                            {{scope.row.companycode|dictname('xsyb_gongsi')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="税分类编码"
                            prop="taxCode"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            label="套餐价格"
                            prop="packagePrice"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            label="状态"
                            prop="status"
                            width="110">
                        <template slot-scope="scope">
                            {{scope.row.status|dictname('bsom_status')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="套餐开始时间"
                            prop="packageStarttime"
                            width="110"
                            :formatter="formatDate" >
                    </el-table-column>
                    <el-table-column
                            label="套餐结束时间"
                            prop="packageEndtime"
                            width="110"
                            :formatter="formatDate" >
                    </el-table-column>
                    <el-table-column
                            label="场景"
                            prop="sceneName"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            label="创建人"
                            prop="cuname"
                            width="110">
                    </el-table-column>

                    <el-table-column
                            label="创建时间"
                            prop="cdate"
                            width="110"
                            :formatter="formatDate" >
                    </el-table-column>

                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="280"
                    >
                        <template slot-scope="scope">
                            <el-button
                                    type="text"
                                     size="small"
                                    class="h-tableLink h-btn" @click="toDetail(scope.row)">
                                查看
                            </el-button>
                            <el-button
                                    type="text"
                                    v-if="scope.row.status == 1 || scope.row.status == 2 || scope.row.status == 3"
                                    size="small"
                                    class="h-tableLink h-btn" @click="toChange(scope.row)">
                                修改
                            </el-button>
                            <el-button
                                    type="text"
                                    v-if="scope.row.status == -1"
                                    size="small"
                                    class="h-tableLink h-btn" @click="edit(scope.row)">
                                编辑
                            </el-button>
                            <el-button
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn" @click="toDelete(scope.row)">
                                删除
                            </el-button>
                            <el-button v-if="scope.row.instid" type="text" size="small" class="h-tableLink h-btn" @click="chakanjindu(scope.row.instid)">
                                跟踪
                            </el-button>

                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="showinstid"/>
            <div class="h-tableB h-mrt30">
                <div class="h-tableBL">
                    <el-button type="primary" @click="exportExcel">批量导出</el-button>
                 </div>
                <div class="h-pagination2">
                    <pagination :page="q" @query="query"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    import updownfile from "../../utils/updownfile";
    export default {
        components: {},
        data() {
            return {
                all: '全部',
                q: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    packageCode:null,
                    sceneCode:null,
                    lianqunCode:null,
                    status:null,
                    packageType:null,
                    companycode:null,
                    isTj:'',
                },
                //表单
                f:{
                    id:null, // 
                    prodcode:null, // 产品编码
                    promodel:null, // 产品型号
                    factory:null, // 工厂
                    unit:null, // 单位
                    version:null, // 版本号
                    cdate:null, // 创建日期
                    cucode:null, // 创建人
                    lucode:null, // 更新人
                    ldate:null, // 最后更新时间
                    delflag:null, // 有效标志
                },
                //table列表
                tableData: [],
                //操作标志
                optflag:'save',
                //表格
                multipleSelection: [],
                showhistory: false,
                showinstid: null,
            }
        },
        created() {
            this.query();
        },
        methods: {
            //查看进度
            chakanjindu(q){
                this.showinstid = q;
                this.showhistory = true;
            },
            query(p) {
                if(p){
                    this.q.pageSize = p.pageSize||this.page.size;
                    this.q.pageNo = p.pageNo||this.page.current;
                }
                ss.bom.searchBom(this.q).then(rd=>{
                    this.q.total = rd.total;
                    this.tableData = rd.records;
            })
            },
            handleFilter() {
                this.q.pageNo = 1;
                this.query();
            },
            resetData(){
                this.q = {
                    packageCode:null,
                    sceneCode:null,
                    packageType:null,
                    lianqunCode:'',
                    status:'',
                    companycode:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                }

            },
            //创建新bom
            toNew() {
                this.$router.push({path: '/chanp/bomCreate'});
            },
            //选中
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //修改销售样表
            toChange(value) {
                this.$router.push({path: "/chanp/bomUpdate", query: {id: value.id, showFlag: true}});
            },
            edit(value){
                this.$router.push({path: "/chanp/bomUpdate", query: {id: value.id, showFlag: true}});
            },
            //修改销售样表
            toDetail(value) {
                this.$router.push({path: "/chanp/bomUpdate", query: {id: value.id, showFlag: false}});
            },
            //删除销售样表
            toDelete(value) {
                this.$msg.confirm("确认删除?", () => {
                    ss.bom.toDelete(value.id).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                    });
                });
            },
            //明细导出
            exportExcel() {
/*                var idlist = [];
                this.multipleSelection.forEach(element => {
                    idlist.push(element.id);
                });
                updownfile.down("/api/swyl/v1/bom/bomMain/downloadExcel", idlist, "post", 'data');*/
                updownfile.down("/api/swyl/v1/bom/bomMain/downloadExcel",this.q,"get",'params');
            },
            formatDate(row, column) {
                // 获取单元格数据
                let data = row[column.property]
                if(data == null || data == '') {
                    return null
                }
                let dt = new Date(data)
                return this.$util.riQi3(dt);
            },
        }
    }
</script>